var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7de31c2a96d569a7a192f8a2805e59e7bdf6d9d3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["elo-cabinets@elopage"]={id:"7de31c2a96d569a7a192f8a2805e59e7bdf6d9d3"};
      